import axios from 'axios';
import { Languages } from '../components/languages';

export const Environment = "test";

export const ProfileLevels = ['admin', 'user', 'readonly', 'userPro'];

export function myDeepCopy(par) {
    var cp = par;
    if (!!par && typeof par === 'object') {
		if (Object.prototype.toString.call(par) === '[object Array]') {
			cp = par.map(el => myDeepCopy(el));
		}
		else {
			cp = {};
			Object.entries(par).forEach(([key, val]) => {
				cp[key] = myDeepCopy(val);
			});
		}
	}
	return cp;
};

export function setEmptyStrings(par) {
    var cp = par;
    if (!par) cp = "";
    else if (typeof par === 'object') {
        if (Object.prototype.toString.call(par) === '[object Array]') {
            cp = par.map(el => ((!!el) ? el : ""));
        }
        else {
            cp = {};
            Object.entries(par).forEach(([key, val]) => {
                cp[key] = setEmptyStrings(val);
            });
        }
    }
    return cp;
};

export function plainDate(sdt, wtime) {
// expected format: "2020-07-06T14:58:34.8408398"
    if (sdt == undefined || sdt == null)
        return "";
    var sections = sdt.toString().split("T");
    if (sections.length !== 2) return sdt;

    var dt = sections[0].split("-");
    if (dt.length !== 3) return sdt;

    var sOut = dt[2] + "/" + dt[1] + "/" + dt[0];

    if (wtime) {
        var tm = sections[1].split('.');
        sOut += " " + tm[0];        
    }

    return sOut;
};

export function dateObj(sdt) {
    var par = !sdt ? "" : sdt.toString().substr(0, 10).split("/");
    return (par.length >= 3) ? new Date(par[2], parseInt(par[1]) - 1, par[0]) : "";
};

export function dateStr(dt) {
    return !dt ? "" : ("00" + dt.getDate()).substr(dt.getDate().toString().length, 2) + "/" +
        ("00" + (dt.getMonth() + 1)).substr((dt.getMonth() + 1).toString().length, 2) + "/" + dt.getFullYear();
};


export function buildManageStockAddress() {
    return {
            firstName: '',
            lastName:'',
            newCountry: '',
            newAddress: '',
            newLocation: '',
            newProvince: '',
            newZipcode: ''
    }
}

export function buildManageOrderStockDto() {
    return {
        orderNum: '',
        address: buildManageStockAddress()
    }
}

export function buildCreditBoxRequestDto(method, packetId) {
    return {
        method: method,
        packetId: packetId
    };
}


export function getNavigation(refreshData,navigationLabels) {
    let navigation= {
        pageSize: { value: 10 },
        pageNo: { value: 0 },
        totalItems: { value: 0 }
    };

    navigation.pageSize.change=function(ev, vl) {
        //let newNavig = myDeepCopy(this.state.navigation);
        const offset = navigation.pageNo.value * navigation.pageSize.value;
        navigation.pageNo.value = Math.round(offset / vl);
        navigation.pageSize.value = vl;
        refreshData(navigation);
    }

    navigation.pageNo.change = function (ev, vl) {
        //let newNavig = myDeepCopy(this.state.navigation);
        navigation.pageNo.value = vl;
        refreshData(navigation);

    }
    navigation.pageSize.text = navigationLabels[0];
    navigation.refresh = function (ev, vl) {
      
        refreshData(navigation);
    }

    return navigation;
}

export function ajax(ctx, obj, okfn, errfn, finallyFn) {
    console.log('AJAX called with:', obj);
    axios(obj)
        .then(response => {
            console.log('AJAX success:', response);
            if (typeof okfn === "function") okfn.call(ctx, response);
        })
        .catch(error => {
            console.error('AJAX error details:', {
                status: error.response?.status,
                data: error.response?.data,
                headers: error.response?.headers,
                config: error.config,
            });
            if (!!error && !!error.response && error.response.status === 401) {
                sessionStorage.removeItem("userContext");
            }
            let retError = error;
            if (error.response != undefined && error.response.data != undefined)
                retError = error.response.data;
            if (typeof errfn === "function") errfn.call(ctx, retError);
            console.log(errfn);
        })
        .finally(() => {
            console.log('AJAX finally called');
            if (typeof finallyFn === "function") finallyFn.call(this);
        });
}

export function loadAutocompleteCountries(jwtToken, ok, ko, ctx) {
    ajax(ctx, { method: 'get', url: '/api/param/country-sendabox', headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            ok.call(this,response.data);
        },
        error => {
            ko.call(this, error);
        }
    );
} 


export function autoCompleteForeignCitiesForCountry(jwtToken, country, countryCode, ok, ko) {
    const url = '/api/autocomplete/foreign-cities-for-country';
    ajax(this, {
        method: 'POST',
        url,
        headers: {'Content-Type':"application/json", Authorization: 'Bearer ' + jwtToken },
    
        data: {
            countryCode,
            term: country
        }
    },
        response => {
            ok.call(this, response.data.result.searchAutocompleteCities);
        },
        error => {
            if(ko) {
                ko.call(this, error);
            }
        }
    );
}

export function autoCompleteForeignCities(city,ok, ko) {
    var bodyFormData = new FormData();
    bodyFormData.append('countryId', '1');
    bodyFormData.append('term', city);
    const url = 'https://cors.sendabox.it/cors/AutoComplete/AutoCompleteForeignCities';
    ajax(this, {
        method: 'post', url: url,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        data: 'term=' + city + "&countryId=1"
    },
        response => {

            ok.call(this,response);
        },
        error => {
            ko.call(this, error);
        }
    );
}

export function getReminders(jwtToken, ok) {

    const url = '/api/organization/get-reminders';
    ajax(this, { method: 'get', url: url, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            if (response.data.success)
                ok.call(this, response.data.result.data);
        }
    );
}

export function deleteOrders(orderNums, jwtToken,ok,ko) {
    
    const url = '/api/order/delete-orders';
    ajax(this, { method: 'post', url: url, headers: { Authorization: 'Bearer ' + jwtToken }, data: orderNums },
        response => {

            ok.call(this);
        },
        error => {
            ko.call(this, error);
        }
    );
}
export function deleteOrdersCreation(orderNums, jwtToken, ok, ko) {

    const url = '/api/order/order-creation-delete';
    ajax(this, { method: 'post', url: url, headers: { Authorization: 'Bearer ' + jwtToken }, data: orderNums },
        response => {

            ok.call(this);
        },
        error => {
            ko.call(this, error);
        }
    );
}

export function deleteAllOrdersCreation(jwtToken, ok, ko) {

    const url = '/api/order/all-order-creation-delete';
    ajax(this, { method: 'post', url: url, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {

            ok.call(this);
        },
        error => {
            ko.call(this, error);
        }
    );
}

export function loadUserMessage(jwtToken,section, ok, ko, ctx) {

    let sect = encodeURIComponent(section);
    ajax(ctx, { method: 'get', url: '/api/usermessage/message-section/'+sect, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => { ok.call(this, response.data.result.message); },
        error => { }
    );
}

export function deleteUserMessage(jwtToken, section, ok, ko, ctx) {

    let sect = encodeURIComponent(section);
    const url = '/api/usermessage/message-section-delete/' + sect;
    ajax(this, { method: 'post', url: url, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            ok.call(this);
        },
        error => {
            ko.call(this);
        }
    );

}

export function loadMarketPlaceConfs(jwtToken,ok,ko,ctx) {
    ajax(ctx, { method: 'get', url: '/api/marketplace/marketplace-conf', headers: { Authorization: 'Bearer ' + jwtToken } },
        response => { ok.call(this, response.data.result.marketPlaces); },
        error => { }
    );
} 

export function loadMarketPlaceSet(jwtToken,listOfMarketPlace,ko,ctx) {
    ajax(ctx, { method: 'get', url: '/api/marketplace/marketplace-sets', headers: { Authorization: 'Bearer ' +jwtToken } },
        response => {
            listOfMarketPlace.call(this, response.data.result.markets);
        },
        error => { ko.call(this); }
    );
}


export function loadOrderServices(id, jwtToken,listOf, ko, ctx) {
    ajax(ctx, { method: 'get', url: `/api/order/order-services/${id}`, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            listOf.call(this, response.data);
        },
        error => { ko.call(this); }
    );
}

export function loadPickUpAddress(jwtToken, listOf, ko, ctx) {
    ajax(ctx, { method: 'get', url: '/api/organization/pickup-address', headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            listOf.call(this, response.data);
        },
        error => { ko.call(this); }
    );
}
export function loadRecipientAddresses(jwtToken, listOf, ko, ctx) {
    ajax(ctx, { method: 'get', url: '/api/organization/recipient-address', headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            listOf.call(this, response.data);
        },
        error => { ko.call(this); }
    );
}


export function deletePickUpAddress(id, jwtToken, listOf, ko, ctx) {
    ajax(ctx, { method: 'post', url: `/api/organization/pickup-address-delete/${id}`, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            listOf.call(this, response.data);
        },
        error => { ko.call(this); }
    );
}

export function deleteRecipientAddress(id, jwtToken, listOf, ko, ctx) {
    ajax(ctx, { method: 'post', url: `/api/organization/recipient-address-delete/${id}`, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            listOf.call(this, response.data);
        },
        error => { ko.call(this); }
    );
}


export function loadPackageConfig(jwtToken, listOf, ko, ctx) {
    ajax(ctx, { method: 'get', url: '/api/organization/package-config', headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            listOf.call(this, response.data.result.packageConfig);
        },
        (error) => { ko.call(this, error); }
    );
}
export function loadReturnedOrders(id, jwtToken, listOf, ko, ctx) {
    ajax(ctx, { method: 'get', url: `/api/order/create-returned-order/${id}`, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            listOf.call(this, response.data);
        },
        error => { ko.call(this); }
    );
}

export function loadUPSProvinceCodes(countryCode, jwtToken, ok, ko, ctx) {
    ajax(ctx, { method: 'get', url: `/api/param/ups-province-codes?countryCode=${countryCode}&carrier=UPS`, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => { ok.call(this, response.data); },
        error => { ko.call(this); }
    );
}




export function loadWarehouseConfs(jwtToken, ok, ko, ctx) {
    ajax(ctx, { method: 'get', url: '/api/param/wharehouse', headers: { Authorization: 'Bearer ' + jwtToken } },
        response => { ok.call(this, response.data); },
        error => { }
    );
} 

export function loadCarrierConfs(jwtToken, ok, ko, ctx) {
    ajax(ctx, { method: 'get', url: '/api/carrier/carrier-conf', headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            ok.call(this, response.data.result.carriers);
        },
        error => { }
    );
} 
export function loadCarrierSets(jwtToken, ok, ko, ctx) {
    ajax(this, { method: 'get', url: '/api/carrier/carriers-sets', headers: { Authorization: 'Bearer ' +jwtToken } },
        response => {
            ok.call(this, response.data.result.carriers);
        },
        error => { ko.call(this, error);}
    );
}
export function loadOrganizationCarrier(jwtToken, ok, ko, ctx) {
    ajax(this, { method: 'get', url: '/api/carrier/organization-carrier-conf', headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            ok.call(this, response.data.result.carriers);
        },
        error => { ko.call(this, error); }
    );
}
export function loadMarketPlaceOrders(id, extras, jwtToken, listOf, ko, ctx) {
    ajax(ctx, {
            method: 'post',
            url: '/api/order/order-marketplace/' + id,
            headers: { Authorization: 'Bearer ' + jwtToken },
            data: extras
        },
        response => {
            listOf.call(this, response.data);
        },
        error => {
            
            ko.call(this, error);

        }
    );
} 

export function manageOrderStock(jwtToken, action, data, ok, ko) {
    let act = encodeURIComponent(action);
    data.action = action;
    ajax(this, {
        method: 'post', url: '/api/stock/manage-stock', headers: { Authorization: 'Bearer ' + jwtToken }, data: data
    },
        response => {
            ok.call(this);
        },
        error => {

            ko.call(this, error);

        }
    );
}


export function loadUsersList(jwtToken, ok, ko, ctx) {
    ajax(ctx, { method: 'get', url: '/api/userprofile/user-creds-organization', headers: { Authorization: 'Bearer ' + jwtToken } },
    response => { ok.call(this, response.data.result.userCredsOrganization); },
    error => { ko.call(this); }
);
}

export function loadUserSettings(section, jwtToken, settings, ko, ctx) {
    let sect = encodeURIComponent(section);
    ajax(this, { method: 'get', url: '/api/userprofile/user-settings/' + sect, headers: { Authorization: 'Bearer ' + jwtToken } },
        response => {
            if (section == null || section == '')
                section = "settings";
            if (!response.data.result.hasOwnProperty(section))
                return settings.call(this, {});
            settings.call(this, response.data.result[section]);
        },
        error => {
            ko.call(this, error);
        }
    );

}

export function postUserSettings(section, settings, jwtToken, ok, ko, ctx) {
    let sect = encodeURIComponent(section);
    ajax(this, {
        method: 'post', url: '/api/userprofile/user-settings/' + sect, headers: { Authorization: 'Bearer ' + jwtToken },
        data: settings
    },
        response => {
           
            ok.call(this, response.data.result.id);
        },
        error => {
            ko.call(this, error);
        }
    );
}

export function checkUserSettingsEmail(id, jwtToken, ok, ko, ctx) {
    let sect = encodeURIComponent(id);
    ajax(this, {
        method: 'post', url: '/api/userprofile/user-settings/check-email/' + sect, headers: { Authorization: 'Bearer ' + jwtToken },
        data: {}
    },
        response => {

            ok.call(this, response.data.result.email);
        },
        error => {
            ko.call(this, error);
        }
    );

}
export function downloadFile(url, jwtToken,ko, ctx) {
    const config = {
        responseType: 'blob', headers: { Authorization: 'Bearer ' + jwtToken } };
        axios.get(url, config)
            .then(response => {
                let filename = response.headers['content-disposition'].split('filename=')[1];
                filename = filename.split(";")[0];
                let url = window.URL.createObjectURL(response.data);
                let a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
            })
            .catch(
                error => {
                    
                    ko.call(ctx, error);
                }
            );
}

export function downloadFilePost(url, data, jwtToken, ko, ctx) {
    const config = {
        responseType: 'blob', headers: { Authorization: 'Bearer ' + jwtToken }
    };
    axios.post(url, data, config)
        .then(response => {
            let filename = response.headers['content-disposition'].split('filename=')[1];
            filename = filename.split(";")[0];
            let url = window.URL.createObjectURL(response.data);
            let a = document.createElement('a');
            a.href = url;
            a.download = filename;
            a.click();
        })
        .catch(
            error => {

                ko.call(ctx, error);
            }
        );
}
export function downloadCsv(jwtToken,type, pageNo, pageSize, appliedFilters, ko, ctx) {

    const filters = encodeURIComponent(JSON.stringify(appliedFilters));
    const url = '/api/filemanager/csv/' + type+'/' + pageNo + '/' + pageSize+'/'+filters;

    downloadFile(url, jwtToken,
        error => ko.call(ctx, error));


}

export function downloadOrderLabels(jwtToken,listOfOrdersNum,ko) {

    /*let ordersToken = "";
    for (let i = 0; i < listOfOrdersNum.length; i++) {
        let orderNum = listOfOrdersNum[i];
        ordersToken = ordersToken+";" + orderNum;

    }
    if (ordersToken != "") {*/
    let url = "api/filemanager/order-doc/labels";///" + encodeURI(ordersToken.substr(1));
    downloadFilePost(url, listOfOrdersNum, jwtToken, error => {

            ko.call(this, error);

        });

    /*}*/

}
export function downloadOrdersCsv(jwtToken, listOfOrdersNum, ko) {

    let url = "api/filemanager/order-doc/orders";
    downloadFilePost(url, listOfOrdersNum, jwtToken, error => {
        ko.call(this, error);
    });
}

export function loadRegionZips(jwtToken, idRegion, ok, ko, ctx) {
    if (idRegion) {
        ajax(ctx, {
            method: 'get', url: 'api/param/province-zip/' + encodeURI(idRegion), headers:
                { Authorization: 'Bearer ' + jwtToken }
        },
            response => { ok.call(this, response.data.sort((a, b) => ((a.name < b.name) ? -1 : ((a.name > b.name) ? 1 : 0)))) },
            error => { ko.call(this, error); }
        );
    }
    else {
        ok([]);
    }
} 



export function loadCreditBoxPackets(ctx, jwtToken, ok, ko) {
    ajax(ctx, {
        method: 'get', url: 'api/param/creditbox-packets', headers:
            { Authorization: 'Bearer ' + jwtToken }
    },
        response => { ok.call(this, response.data) },
        error => { ko.call(this, error); }
    );
}

export function getCreditWallet(jwtToken, data, ko, ctx) {
    ajax(ctx, {
        method: 'get', url: '/api/cbPayment/credit-wallet',
        headers: { Authorization: 'Bearer ' + jwtToken }
    },
        response => {
            if (response.data.success)
                data.call(this, response.data.result);
            else
                ko.call(this);
        },
        error => { ko.call(this); }
    );
}
export function getCreditWalletInfo(jwtToken, data, ko, ctx) {
    ajax(ctx, {
        method: 'get', url: '/api/cbPayment/credit-wallet-info',
        headers: { Authorization: 'Bearer ' + jwtToken }
    },
        response => {
            if (response.data.success)
                data.call(this, response.data.result);
            else
                ko.call(this);
        },
        error => { ko.call(this); }
    );
} 

export function ellipsisText(text, length) {

    return text.substr(0, length - 1) + (text.length > length ? '...' : '');

}

export function showPopup(popupMessage, title, icon, message,
    confirmText, cancelText, okFn, koFn) {
    if(cancelText.length  === 0) {
        popupMessage({
            title: title,
            icon: icon,
            messages: [message],
            buttons: [
                {
                    name: "confirm", width: "35%", type: "confirm", text: confirmText, class: "right",
                    click: okFn
                }
            ]
        });
        return;
    }

    popupMessage({
        title: title,
        icon: icon,
        messages: [message],
        buttons: [
            {
                name: "cancel", width: "35%", type: "cancel", text: cancelText, class: "right",
                click: koFn
            },
            {
                name: "confirm", width: "35%", type: "confirm", text: confirmText, class: "right",
                click: okFn
            }
        ]
    });
}

export function showAlertPopup(popupMessage, popupConfig,okFn) {

    popupMessage({
        title: popupConfig.title,
        icon: popupConfig.icon,
        messages: popupConfig.hasOwnProperty("message") ? popupConfig.message : popupConfig.messages,
        buttons: [
            {
                name: "confirm", width: "35%", type: "confirm", text: popupConfig.button, class: "right",
                click: okFn
            }
        ]
    });
}
export function showErrorPopup(popupMessage, popupConfig, okFn) {

    popupMessage({
        title: popupConfig.title,
        icon: "error",
        messages: popupConfig.hasOwnProperty("message") ? popupConfig.message : popupConfig.messages,
        buttons: [
            {
                name: "confirm", width: "35%", type: "confirm", text: popupConfig.button, class: "right",
                click: okFn
            }
        ]
    });
}


export function validateCarrierRules(carrier, orderNum, packages, orderRecipientZip, hasCountersign, country, orderServices) {
    /*
     *  0 => OK
     *  1 => Regole non impostate" -- x ora ignoro...
     *  2 => numero colli
     *  3 => dimensione collo
     *  4 => peso collo
     *  5 => peso totale
     *  6 => non gestisce contrassegno
     *  7 => gestisce solo con contrassegno
     *  8 => zip out of range
     *  9 => corriere non abilitato a spedire nel Paese selezionato
     *  10 => non gestisce triangolazione (triangulation error message)
     */

    if (carrier == null || carrier.rules == null) {
        //failures.push(leRules[1]);
        return null;
    } else {
        let rules = carrier.rules;
        let leRules = Languages.Couriers[Languages.selectedLanguage].checkRuleResult;

        let failures = [];

        // check numero colli
        if (rules.packageMin && packages.length < rules.packageMin)
            failures.push(leRules[2]);
        else if (rules.packageMax && packages.length > rules.packageMax)
            failures.push(leRules[2]);

        // check peso/dimensione colli
        let totWeight = 0;
        for (let pack of packages) {
            let size = Number(pack.depth.value) + Number(pack.height.value) + Number(pack.length.value);
            let weight = carrier.applyVolumetricWeight
                ? Math.max(Number(pack.weight.value), (Number(pack.depth.value) * Number(pack.height.value) * Number(pack.length.value) / 1000000 /*cm3 => m3*/) * (rules.volumetricWeightParam || 0))
                : Number(pack.weight.value);
            
            if (rules.minSize && size < rules.minSize) {
                failures.push(leRules[3]);
            }
            else if (rules.maxSize && size > rules.maxSize) {
                failures.push(leRules[3]);
            }
            if (rules.minWeight && weight < rules.minWeight) {
                failures.push(leRules[4]);
            }
            else if (rules.maxWeight && weight > rules.maxWeight) {
                failures.push(leRules[4]);
            }
            totWeight += weight;
        } if (rules.minWeightTot && totWeight < rules.minWeightTot) {
            failures.push(leRules[5]);
        } else if (rules.maxWeightTot && totWeight > rules.maxWeightTot) {
            failures.push(leRules[5]);
        }

        if (rules.countersign && hasCountersign && rules.countersign.toLowerCase() == "senza contrassegno") {
            failures.push(leRules[6]);
        }
        if (rules.countersign && !hasCountersign && rules.countersign.toLowerCase() == "con contrassegno") {
            failures.push(leRules[7]);
        }

        if (rules.region) {
            let zipOk = false;
            if (rules.zipRanges && orderRecipientZip) {
                for (let range of rules.zipRanges) {
                    if (orderRecipientZip >= range.min && orderRecipientZip <= range.max) {
                        zipOk = true;
                        break;
                    }
                }
            }
            if (!zipOk) {
                failures.push(leRules[8]);
            }
        }

        //if (country.toUpperCase() !== "ITALIA" && country.toUpperCase() !== "IT") {
            if (rules.enabledForeignIdCountries.length <= 0 || !rules.enabledForeignIdCountries.some(s => s.localeCompare(country, undefined, { sensitivity: 'base' }) === 0)) {
                failures.push(leRules[9]);
            }
        //}
//chkAssurance
        if (orderServices?.chkCountersign?.val && !carrier?.counterSign) {
            failures.push(leRules[6]);
        }
        if (orderServices?.chkTriangulation?.val && !carrier?.triangulation) {
            failures.push(leRules[10]);
        }

        if (failures.length > 0) {
            failures.unshift(leRules[0].replace("{0}",carrier.sign) + orderNum);
        }

        return failures;
    }
}


export const marketplacesLogoList = [
    { name: 'Amazon', logo: '../images/marketplaces/Amazon2.png' },
    { name: 'eBay', logo: '../images/marketplaces/Ebay2.png' },
    { name: 'Magento (V' + '\xa0' + '2.x)', logo: '../images/marketplaces/MagentoV2.png' },
    { name: 'Magento', logo: '../images/marketplaces/Magento2.png' },
    { name: 'Shopify', logo: '../images/marketplaces/Shopify2.png' },
    { name: 'Prestashop', logo: '../images/marketplaces/Prestashop2.png' }
];

export const couriersLogoList = [
    {
        id: '1', sign: 'BRT', name: 'Bartolini', logo: '../images/couriers/Bartolini2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '2', sign: 'NEX', name: 'Nexive', logo: '../images/couriers/Nexive2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '3', sign: 'ITP', name: 'Poste Italiane', logo: '../images/couriers/Poste2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '4', sign: 'SDA', name: 'SDA', logo: '../images/couriers/SDA2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '5', sign: 'SLP', name: 'SailPost', logo: '../images/couriers/SailPost2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '6', sign: 'DHL', name: 'DHL', logo: '../images/couriers/DHL2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '7', sign: 'GLS', name: 'GLS', logo: '../images/couriers/GLS2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '8', sign: 'SGT', name: 'SGT', logo: '../images/couriers/SGT2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '9', sign: 'SKN', name: 'Skynet', logo: '../images/couriers/Skynet2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    },
    {
        id: '10', sign: 'UPS', name: 'UPS', logo: '../images/couriers/UPS2.png',
        details: [
            { type: 'text', id: 'previousCourier', value: '' },
            { type: 'text', id: 'account', value: '' },
            { type: 'text', id: 'userId', value: '' },
            { type: 'text', id: 'password', value: '' },
            { type: 'text', id: 'accessKey', value: '' },
            { type: 'label', id: 'labelType', value: null },
            { type: 'checkbox', id: 'chkA4', value: false },
            { type: 'checkbox', id: 'chkPDF', value: false },
            { type: 'checkbox', id: 'chkZPL', value: false }
        ]
    }
];

export const warehousesList = [
    { name: 'Italmondo', address: 'Corso Eugenio Mariposa 71 Trezzano Sul Naviglio, MI 20090' },
    { name: 'Lainate', address: 'Via Marcello Battista 32 Lainate, MI 20134' },
    { name: 'SupernovaHUB', address: 'Piazzale Cacciatori delle Alpi 1 Milano, MI 20156' },
    { name: 'Arluno', address: 'Via Bologna 134 Arluno, MI 20156' }
];

export const provinces = {
    'Abruzzo': [{ name: 'Chieti', zip: '66010 - 66100' }, { name: 'L\'Aquila', zip: '67010 - 67100' }, { name: 'Pescara', zip: '65010 - 65129' }, { name: 'Teramo', zip: '64010 - 64100' }],
    'Basilicata': [{ name: 'Matera', zip: '75010 - 75100' }, { name: 'Potenza', zip: '85010 - 95047' }],
    'Calabria': [{ name: 'Catanzaro', zip: '88020 - 88100' }, { name: 'Cosenza', zip: '87010 - 87100' }, { name: 'Crotone', zip: '88811 - 88900' }, { name: 'Reggio di Calabria', zip: '89010 - 89135' }, { name: 'Vibo Valentia', zip: '89812 - 89900' }],
    'Campania': [{ name: 'Avellino', zip: '83010 - 83100' }, { name: 'Benevento', zip: '82010 - 82100' }, { name: 'Caserta', zip: '81010 - 81100' }, { name: 'Napoli', zip: '80010 - 80147' }, { name: 'Salerno', zip: '84010 - 84135' }],
    'Emilia Romagna': [{ name: 'Bologna', zip: '40010 - 40141' }, { name: 'Ferrara', zip: '44010 - 44100' }, { name: 'Forlì-Cesena', zip: '47010 - 47100' }, { name: 'Modena', zip: '41010 - 41100' }, { name: 'Parma', zip: '43010 - 43100' }, { name: 'Piacenza', zip: '29010 - 29100' }, { name: 'Ravenna', zip: '48010 - 48100' }, { name: 'Reggio nell\'Emilia', zip: '42010 - 42100' }, { name: 'Rimini', zip: '47814 - 61019' }],
    'Friuli Venezia Giulia': [{ name: 'Gorizia', zip: '34070 - 34170' }, { name: 'Pordenone', zip: '33070 - 33170' }, { name: 'Trieste', zip: '34010 - 34151' }, { name: 'Udine', zip: '33010 - 33100' }],
    'Lazio': [{ name: 'Frosinone', zip: '03010 - 03100' }, { name: 'Latina', zip: '04010 - 04100' }, { name: 'Rieti', zip: '02010 - 2011' }, { name: 'Roma', zip: '00010 - 00199' }, { name: 'Viterbo', zip: '01010 - 01100' }],
    'Liguria': [{ name: 'Genova', zip: '16010 - 16167' }, { name: 'Imperia', zip: '18010 - 18100' }, { name: 'La Spezia', zip: '19010 - 19137' }, { name: 'Savona', zip: '12071 - 17100' }],
    'Lombardia': [{ name: 'Bergamo', zip: '16192 - 73030' }, { name: 'Brescia', zip: '25010 - 38083' }, { name: 'Como', zip: '22010 - 22100' }, { name: 'Cremona', zip: '26010 - 26100' }, { name: 'Lecco', zip: '23801 - 23900' }, { name: 'Lodi', zip: '26811 - 26900' }, { name: 'Mantova', zip: '46010 - 46100' }, { name: 'Milano', zip: '20010 - 20162' }, { name: 'Monza e della Brianza', zip: '20020 - 20900' }, { name: 'Pavia', zip: '27010 - 95028' }, { name: 'Sondrio', zip: '23010 - 23100' }, { name: 'Varese', zip: '21010 - 21100' }],
    'Marche': [{ name: 'Ancona', zip: '60010 - 60131' }, { name: 'Ascoli Piceno', zip: '63010 - 63100' }, { name: 'Fermo', zip: '63010 - 63900' }, { name: 'Macerata', zip: '62010 - 62100' }, { name: 'Pesaro e Urbino', zip: '61010 - 61100' }],
    'Molise': [{ name: 'Campobasso', zip: '86010 - 86100' }, { name: 'Isernia', zip: '86070 - 86170' }],
    'Piemonte': [{ name: 'Alessandria', zip: '15010 - 15100' }, { name: 'Asti', zip: '14010 - 38060' }, { name: 'Biella', zip: '13811 - 13900' }, { name: 'Cuneo', zip: '12010 - 18025' }, { name: 'Novara', zip: '28010 - 28100' }, { name: 'Torino', zip: '10010 - 38059' }, { name: 'Verbano-Cusio-Ossola', zip: '28801 - 28925' }, { name: 'Vercelli', zip: '13010 - 13100' }],
    'Puglia': [{ name: 'Bari', zip: '70010 - 70131' }, { name: 'Barletta-Andria-Trani', zip: '70031 - 76125' }, { name: 'Brindisi', zip: '72010 - 72100' }, { name: 'Foggia', zip: '71010 - 71100' }, { name: 'Lecce', zip: '73010 - 73100' }, { name: 'Taranto', zip: '74010 - 74100' }],
    'Sardegna': [{ name: 'Cagliari', zip: '08030 - 09134' }, { name: 'Carbonia-Iglesias', zip: '09010 - 09017' }, { name: 'Medio Campidano', zip: '09020 - 09040' }, { name: 'Nuoro', zip: '08010 - 08100' }, { name: 'Ogliastra', zip: '08037 - 08049' }, { name: 'Olbia-Tempio', zip: '07020 - 08020' }, { name: 'Oristano', zip: '08010 - 09170' }, { name: 'Sassari', zip: '07010 - 07100' }],
    'Sicilia': [{ name: 'Agrigento', zip: '92010 - 92100' }, { name: 'Caltanissetta', zip: '93010 - 93100' }, { name: 'Catania', zip: '95010 - 95131' }, { name: 'Enna', zip: '94010 - 94100' }, { name: 'Messina', zip: '08020 - 98168' }, { name: 'Palermo', zip: '90010 - 90151' }, { name: 'Ragusa', zip: '97010 - 97100' }, { name: 'Siracusa', zip: '96010 - 96100' }, { name: 'Trapani', zip: '91010 - 91100' }],
    'Toscana': [{ name: 'Arezzo', zip: '52010 - 52100' }, { name: 'Firenze', zip: '50010 - 50145' }, { name: 'Grosseto', zip: '58010 - 58100' }, { name: 'Livorno', zip: '57014 - 57128' }, { name: 'Lucca', zip: '55010 - 55100' }, { name: 'Massa-Carrara', zip: '54010 - 54100' }, { name: 'Pisa', zip: '56010 - 56128' }, { name: 'Pistoia', zip: '51010 - 51100' }, { name: 'Prato', zip: '59011 - 59100' }, { name: 'Siena', zip: '53011 - 53100' }],
    'Trentino Alto Adige': [{ name: 'Bolzano/Bozen', zip: '39010 - 39100' }, { name: 'Trento', zip: '38010 - 38100' }],
    'Umbria': [{ name: 'Perugia', zip: '06010 - 06135' }, { name: 'Terni', zip: '05010 - 05100' }],
    'Valle d\'Aosta': [{ name: 'Valle d\'Aosta', zip: '11010 - 11100' }],
    'Veneto': [{ name: 'Belluno', zip: '32010 - 32100' }, { name: 'Padova', zip: '35010 - 35143' }, { name: 'Rovigo', zip: '45010 - 45100' }, { name: 'Treviso', zip: '31010 - 31100' }, { name: 'Venezia', zip: '30010 - 40046' }, { name: 'Verona', zip: '37010 - 37142' }, { name: 'Vicenza', zip: '36010 - 36100' }]
};

export const LabelStatusColor = {
    completed: "#2f2f2f",
    ready: "#0aff00",
    running: "#f9ae31",
    stock: "#a7a7a7",
    updating: "#5ca0fc",
    error: "#ed5b5b"
}


export const countries = [
    {
        name: "AUSTRALIA",
        zipCountryValidation: /^\d{4}$/
    },
    {
        name: "AUSTRIA",
        zipCountryValidation: /^\d{3,4}$/
    },
    {
        name: "BELGIO",
        zipCountryValidation: /^\d{3,4}$/
    },
    {
        name: "BRASILE",
        zipCountryValidation: /^\d{5}-\d{3}$/
    },
    {
        name: "BULGARIA",
        zipCountryValidation: /^\d{3,4}$/
    },
    {
        name: "CANADA",
        zipCountryValidation: /^([A-Z]\d[A-Z])(\s+\d[A-Z]\d)?/
    },
    {
        name: "CINA",
        zipCountryValidation: /^\d{6}$/
    },
    {
        name: "CROAZIA",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "DANIMARCA",
        zipCountryValidation: /^\d{3,4}$/
    },
    {
        name: "ESTONIA",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "FINLANDIA",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "FRANCIA",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "GERMANIA",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "GIAPPONE",
        zipCountryValidation: /^\d{3}\-\d{0,4}$/
    },
    {
        name: "GRECIA",
        zipCountryValidation: /^\d{3}\s?\d{0,2}$/
    },
    {
        name: "IRLANDA DEL NORD",
        zipCountryValidation: /^([A-Z]\d[A-Z\d\s]|[A-Z]{2}\d)[A-Z\d\s]{0,5}/
    },
    {
        name: "ITALIA",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "LETTONIA",
        zipCountryValidation: /^\d{3,4}$/
    },
    {
        name: "LITUANIA",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "LUSSEMBURGO",
        zipCountryValidation: /^\d{3,4}$/
    },
    {
        name: "MALTA",
        zipCountryValidation: null
    },
    {
        name: "NORVEGIA",
        zipCountryValidation: /^\d{3,4}$/
    },
    {
        name: "PAESI BASSI",
        zipCountryValidation: /^(NL-\d{0,4}|\d{2,4})(\s[A-Z]{0,2})?/
    },
    {
        name: "POLONIA",
        zipCountryValidation: /^\d\d-?\d{0,3}$/
    },
    {
        name: "PORTOGALLO",
        zipCountryValidation: /^\d{3,4}$/
    },
    {
        name: "PRINC. DI MONACO",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "REGNO UNITO",
        zipCountryValidation: /^([A-Za-z]\d[A-Za-z\d\s]|[A-Za-z]{2}\d)[A-Za-z\d\s]{0,5}$/
    },
    {
        name: "REPUBBLICA CECA",
        zipCountryValidation: /^\d{3}\s?\d{0,2}$/
    },
    {
        name: "ROMANIA",
        zipCountryValidation: /^\d{3,6}$/
    },
    {
        name: "SAN MARINO",
        zipCountryValidation: /^\d{3,5}$/
    },
    {
        name: "SLOVACCHIA",
        zipCountryValidation: /^\d{3}\s?\d{0,2}$/
    },
    {
        name: "SLOVENIA",
        zipCountryValidation: /^\d{3,4}$/
    },

    {
        name: "SPAGNA",
        zipCountryValidation: /^[0-5]\d{2,4}$/
    },

    {
        name: "STATI UNITI",
        zipCountryValidation: /^\d{3,5}$/
    },

    {
        name: "SVEZIA",
        zipCountryValidation: /^\d{3,5}$/
    },

    {
        name: "SVIZZERA",
        zipCountryValidation: /^\d{3,4}$/
    },

    {
        name: "TURCHIA",
        zipCountryValidation: /^\d{5}$/
    },

    {
        name: "UNGHERIA",
        zipCountryValidation: /^\d{3,4}$/
    },

    {
        name: "SPAGNA - ISOLE CANARIE",
        zipCountryValidation: /^[0-5]\d{2,4}$/
    },
]

export const UPSCourier = "UPS";
export const USCountryCode = "US";
export const canadaCountryCode = "CA";